const ControlsActionTypes = {
    TOGGLE_CONTROLS_OPEN : 'TOGGLE_CONTROLS_OPEN',
    DISABLE_CONTROL_TOGGLE : 'DISABLE_CONTROL_TOGGLE',
    UPDATE_VOICE_AUDIO_SETTINGS : 'UPDATE_VOICE_AUDIO_SETTINGS',
    UPDATE_MASTER_AUDIO_SETTINGS : 'UPDATE_MASTER_AUDIO_SETTINGS',
    UPDATE_PAUSED : 'UPDATE_PAUSED',
    ADD_SETTINGS : 'ADD_SETTINGS',
    UPDATE_CURRENT_CONTROL_SETTING : 'UPDATE_CURRENT_CONTROL_SETTING',
}

export default ControlsActionTypes